export interface Address {
  name: string
  streetAddress: string
  city: string
  state: string
  zipCode: string
  country: string
  id: string
  latitude?: number
  longitude?: number
}

export const defaultAddressValues = {
  name: '',
  streetAddress: '',
  city: '',
  state: '',
  zipCode: '',
  country: 'United States of America',
  id: '',
  latitude: null,
  longitude: null,
}

export const testAddressValues = {
  name: 'Link Software',
  streetAddress: '123 Main Street',
  city: 'Lenoir City',
  state: 'TN',
  zipCode: '37772',
  country: 'United States of America',
  id: '1',
  latitude: 35.80933,
  longitude: -84.26349,
}
